<!-- ButtonSecondary.vue -->
<script setup>
const props = defineProps({
    button: {
        type: [Object, Boolean],
        required: false,
        default: false,
    },
    label: {
        type: String,
        required: false,
        default: '',
    },
    link: {
        type: [String, Boolean],
        required: false,
        default: false,
    },
    icon: {
        type: [String, Boolean],
        required: false,
        default: false,
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
    filledIn: {
        type: Boolean,
        required: false,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    link: {
        type: [String, Boolean],
        required: false,
        default: false,
    },
});
</script>

<template>
    <MessButton v-if="!link" class="button-secondary" :class="{ 'filled-in': filledIn }" :button="button" :label="label"
        :link="link" :icon="icon" :title="title" :disabled="disabled" @click="$emit('click')">
        <slot></slot>
    </MessButton>
    <MessLink v-else class="button-secondary" :class="{ 'filled-in': filledIn }" :href="link" :title="title"
        :disabled="disabled">
        <slot></slot>
    </MessLink>
</template>

<style lang="scss" scoped>
.button-secondary {
    --background-color: none;
    align-self: flex-start;
    color: var(--teal, #042729);
    text-align: center;
    font-family: 'Lexend Deca';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    border: 1.5px solid var(--teal, #042729);
    padding: 1.125rem 1.5rem;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    display: flex;
    justify-content: center;

    &:hover {
        background-color: var(--teal, #042729);
        color: var(--Neutrals-White, #fff);
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    .fragments-loading {
        margin-right: 0.5rem;
    }

    &.filled-in {
        background-color: var(--teal, #042729);
        color: var(--Neutrals-White, #fff);

        &:hover {
            background-color: var(--Neutrals-White, #fff);
            color: var(--teal, #042729);
        }
    }
}
</style>
